
import { LeafletMap } from './map.js';

if( document.getElementById('etablissement-map') ){
    var map = new LeafletMap('etablissement-map');

    $.ajax({
        url: themeajax.ajaxurl,
        type: "POST",
        dataType:'json',
        data: {
            action: "univi_etablissement_map_ajax_action",
            post_id: $('#etablissement-map').attr('data-postid')
        }

    }).done(function(response) {

        //console.log(response);

        let marker = map.addMarker([response.lat, response.lng], response.html, response.color);

        marker.popup.options.maxWidth = 280;

        map.setOpenMarker(marker);
        marker.marker.openPopup();

        map.setCenter([response.lat, response.lng], 11);

    });

    
}

import GLightbox from 'glightbox';

$('.see-all[data-id]').on('click', function(e){
    e.preventDefault();
    var post_id = $(this).attr('data-id');

    $('#etablissement_modal_gallery').removeClass('open');

    $('#etablissement_modal_gallery').fadeIn(200);

    $('body').css({
        overflow: 'hidden',
        height: '100%'
    });

    $.ajax({
        url: themeajax.ajaxurl,
        type: "POST",
        dataType:'html',
        data: {
            action: "univi_etablissement_gallery",
            post_id: post_id
        }

    }).done(function(response) {

        $('#etablissement_modal_gallery .gallery-wrapper').html(response);
        $('#etablissement_modal_gallery').addClass('open');

        const lightbox = GLightbox({
            selector:'#etablissement_modal_gallery .glightbox',
            touchNavigation: true,
            loop: false,
            autoplayVideos: true,
            zoomable:false
        });

    });
});

$('#etablissement_modal_gallery .back').on('click', function(e){
    e.preventDefault();
    $('#etablissement_modal_gallery').fadeOut(150);

    $('body').css({
        overflow: 'auto',
        height: 'auto'
    });
});
